import {Base} from "@/api/Base"

export class GiAdd extends Base {
    path = "gi/add"
}